import { SET_PROFILE_LOADING, SET_PROFILE, LOG_OUT, UPDATE_PROFILE } from '../actions/profile';

const initialData = {
	name: null,
	uid: null,
	email: null,
	loading: false,
	loaded: false,
	isAuth: null,
	subId: null,
};

const initialState = { ...initialData };

export default function profileReducer(state = initialState, action) {
	switch (action.type) {
		case SET_PROFILE_LOADING:
			return { ...state, loading: action.payload };
		case SET_PROFILE:
			return {
				...state,
				...action.payload,
				isAuth: true,
				loaded: true,
				loading: false,
			};
		case LOG_OUT: {
			localStorage.removeItem('token');
			return { ...initialData, isAuth: false };
		}
		default:
			return state;
	}
}
